<div app-modal-content class="w-[80vw] p-0! pb-8">
  <app-modal-header>
    <div class="flex">
      <div
        class="h-16 w-16 shrink-0 self-start rounded-tl-lg bg-green-700 p-2 text-base-status-warning [box-shadow:0px_2px_4px_0px_rgba(0,0,0,0.15)]"
      >
        <svg-icon src="assets/icons/icon-new-course.svg"></svg-icon>
      </div>
      <hr app-modal-divider />
      <div class="flex items-center gap-2">
        <p class="text-3xl font-medium not-italic leading-[normal]" translate>trilhas.estudio.curso.titulo</p>
      </div>
    </div>
  </app-modal-header>

  <app-sidenav-group class="h-[76vh]!">
    <ng-template app-sidenav-start [opened]="true" class="px-4!">
      <div
        class="flex h-full flex-col items-start justify-between gap-4 px-4! [box-shadow:0px_2px_8px_0px_rgba(0,0,0,0.15)]"
      >
        <div class="flex items-center justify-start px-4 pt-5">
          <p class="text-xl font-medium not-italic leading-[normal]" translate>trilhas.estudio.curso.dados-gerais</p>
        </div>

        <hr app-divider class="w-full" />

        <div class="h-[60vh] w-full overflow-y-auto px-4!">
          <div class="grid w-full grid-cols-2">
            <div class="col-span-1">
              <label class="text-[14px]!" translate>geral.status</label>
              <div class="flex gap-2 py-3">
                <app-switch [formControl]="form.controls.status"></app-switch>
                <label class="text-[14px]!" app-label translate>trilhas.estudio.curso.publicado</label>
              </div>
              <div class="flex gap-2 py-3">
                <app-switch [formControl]="form.controls.voucher_productos" id="checkboxToggleProduct"></app-switch>
                <label class="text-[14px]!" app-label translate>trilhas.estudio.curso.voucher</label>
              </div>
            </div>
            <div class="col-span-1">
              <div>
                <label class="text-[14px]!" translate>trilhas.estudio.curso.certificado</label>
                <div class="flex items-center py-3">
                  <app-switch
                    [formControl]="form.controls.emite_certificado"
                    (change)="verifyCamposCertificado()"
                  ></app-switch>
                  <label class="px-2 pb-0! text-[14px]!" app-label translate>trilhas.estudio.curso.emitir</label>
                  <button
                    class="relative right-2"
                    app-icon-button
                    app-tooltip
                    type="button"
                    [tooltip]="'trilhas.estudio.curso.popover-emitir' | translate"
                  >
                    <svg-icon src="assets/icons/icon-interrogation.svg" class="w-4"></svg-icon>
                  </button>
                </div>
                @if (form.value.emite_certificado) {
                  <div class="flex items-center py-3">
                    <app-switch
                      [formControl]="form.controls.sugerir_certificado"
                      (change)="verifyCamposCertificado()"
                    ></app-switch>
                    <div class="flex items-center">
                      <label class="px-2 pb-0! text-[14px]!" app-label translate>trilhas.estudio.sugerir</label>
                      <button
                        class="relative right-2"
                        app-icon-button
                        app-tooltip
                        type="button"
                        [tooltip]="'trilhas.estudio.curso.popover-sugerir' | translate"
                      >
                        <svg-icon src="assets/icons/icon-interrogation.svg" class="w-4"></svg-icon>
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          @if (form.value.emite_certificado && form.value.sugerir_certificado) {
            <div class="flex justify-center py-6">
              <button
                (click)="onAddCertificate()"
                app-outline-button
                class="w-full border-[#11324b] text-[14px] text-[#00324a] hover:[&:not([disabled])]:bg-[#11324b] hover:[&:not([disabled])]:text-theme-contrast"
                type="button"
              >
                {{ 'trilhas.estudio.curso.escolher-certificado' | translate }}
              </button>
            </div>
            <div class="w-full">
              <div class="m-0">
                @if (!!form.value.sugestao_certificado) {
                  <table>
                    <thead>
                      <tr>
                        <th class="text-center">
                          {{ 'trilhas.estudio.curso.certificado' | translate }}
                        </th>
                        <th class="w-3/4">
                          {{ 'geral.titulo' | translate }}
                        </th>
                        <th class="text-center">
                          {{ 'geral.acoes' | translate }}
                        </th>
                      </tr>
                    </thead>
                    <tbody class="cursor">
                      <tr class="cursor border-b border-t border-blue-300 bg-[#f1f6fa] text-center">
                        <td class="w-[60%] p-2 text-center">
                          <app-preview-certificado [data]="onData()"></app-preview-certificado>
                        </td>
                        <td class="p-2">
                          {{ form.value.sugestao_certificado.titulo }}
                        </td>
                        <td class="flex h-[20vh] items-center justify-center space-x-2 p-2">
                          <button
                            app-icon-button
                            class="rounded-lg shadow-md"
                            app-tooltip
                            [tooltip]="'geral.editar' | translate"
                            (click)="edit()"
                          >
                            <svg-icon class="h-5 w-5 text-theme-900" src="assets/icons/icon-edit.svg"></svg-icon>
                          </button>
                          <button
                            app-icon-button
                            type="button"
                            class="rounded-lg shadow-md"
                            app-tooltip
                            [tooltip]="'geral.visualizar' | translate"
                            (click)="onOpenModalCertificado(form.value.sugestao_certificado_id)"
                          >
                            <svg-icon class="flex h-5 w-5 text-theme-900" src="assets/icons/icon-eyes.svg"></svg-icon>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                } @else {
                  <div class="mb-2 text-center">
                    <app-jumbotron>{{
                      'trilhas.certificado.nenhum-certificado-selecionado' | translate
                    }}</app-jumbotron>
                  </div>
                }
              </div>
            </div>
          }
          <div class="flex flex-col items-start gap-2 self-stretch pb-6">
            <p class="text-[14px]!">{{ 'trilhas.estudio.curso.imagem' | translate }} *</p>
            <app-upload-file
              class="w-full"
              [config]="config"
              [image]="thumbnailLink"
              [invalid]="form.controls.thumbnail.invalid && submittedCourse$ | async"
              (statusChange)="onUploadThumbnailCourse($event)"
              (processing)="disableSendUploadThumbnail($event)"
              (queueComplete)="enableSendOnUploadThumbnail($event)"
            ></app-upload-file>
          </div>
          <app-form-field>
            <label class="text-[14px]!" app-label translate>trilhas.estudio.curso.categoria</label>
            <ng-select
              app-select
              [formControl]="form.controls.categoria_id"
              [placeholder]="'trilhas.categoria.selecione-uma-categoria' | translate"
              [items]="data.categories"
              bindValue="id"
              bindLabel="nome"
              [multiple]="false"
              [clearable]="false"
            >
            </ng-select>
          </app-form-field>
          <app-form-field>
            <label class="text-[14px]!" app-label translate>trilhas.estudio.curso.colecao</label>
            <ng-select
              app-select
              [formControl]="form.controls.colecao_id"
              [placeholder]="'trilhas.estudio.curso.selecione-colecao' | translate"
              [items]="categoryCollections(form.controls.categoria_id.value)"
              bindValue="id"
              bindLabel="nome"
              [multiple]="false"
              [clearable]="false"
            >
            </ng-select>
          </app-form-field>
          <app-form-field>
            <label class="text-[14px]!" app-label translate>geral.titulo</label>
            <input
              app-input
              (change)="onChangeCharacter()"
              [placeholder]="'geral.titulo' | translate"
              [formControl]="form.controls.titulo"
            />
          </app-form-field>
          <app-form-field>
            <label class="text-[14px]!" app-label translate>geral.descricao</label>
            <app-text-editor
              [formControl]="descricaoControl"
              [url]="ckeditorUploadImageUrl"
              class="h-80!"
            ></app-text-editor>
          </app-form-field>
        </div>
        <div class="flex w-full items-center justify-between gap-4 p-4">
          @if (form?.value?.id) {
            <div class="flex flex-1 gap-4">
              <button
                (click)="onDelete()"
                app-outline-button
                class="w-full border-red-500 text-red-500 hover:bg-red-500 hover:text-theme-contrast"
                type="button"
              >
                <span class="font-medium uppercase" translate>geral.excluir</span>
              </button>
            </div>
          }
          <div class="flex flex-1 justify-end gap-2">
            <button
              (click)="onSubmit()"
              [disabled]="thumbInvalid$ | async"
              app-outline-button
              class="w-full border-theme-500 text-theme-500 hover:[&:not([disabled])]:bg-theme-500 hover:[&:not([disabled])]:text-theme-contrast"
              type="button"
            >
              @if (thumbInvalid$ | async) {
                <app-skeleton class="h-5! w-5!" baseStyle="bg-theme-500" [showLabel]="false"></app-skeleton>
              }
              <span class="font-medium uppercase" translate>trilhas.estudio.curso.salvar</span>
            </button>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template app-sidenav-outer>
      @if (data?.course?.id) {
        <div class="contents">
          @if (items$ | async; as items) {
            @if (!!items.length) {
              <div class="py-5 pl-10 pr-10">
                <div class="flex items-start justify-between gap-5 pb-5">
                  <h1 class="text-2xl font-semibold text-[#3F4046]" translate>site-escola.conteudos</h1>
                  <div class="flex gap-5">
                    @if (!hasTrails()) {
                      <button
                        (click)="openSidenav()"
                        app-outline-button
                        type="button"
                        class="flex gap-2 border-theme-500 px-4 py-2 uppercase text-theme-500 hover:[&:not([disabled])]:bg-theme-500 hover:[&:not([disabled])]:text-theme-contrast"
                      >
                        <svg-icon class="h-4 w-4" src="assets/icons/icon-more.svg"></svg-icon>
                        {{ 'trilhas.estudio.curso.subdivisao' | translate }}
                      </button>
                    }
                    @if (!hasSubdivisions()) {
                      <button
                        app-button
                        (click)="onAddTrail()"
                        type="button"
                        class="flex gap-2 bg-theme-500 px-4 py-2 uppercase text-theme-contrast"
                      >
                        <svg-icon class="h-4 w-4" src="assets/icons/icon-more.svg"></svg-icon>
                        {{ 'trilhas.estudio.curso.trilha' | translate }}
                      </button>
                    }
                  </div>
                </div>
                <div>
                  @for (item of items; let last = $last; let first = $first; track item) {
                    <div class="mb-10">
                      @if (isSubdivisao(item)) {
                        <app-tree-subdivision
                          [ngClass]="{ 'mb-4': !last }"
                          [subdivision]="item"
                          [items]="items"
                          [first]="first"
                          [last]="last"
                          (order)="reorder($event)"
                        ></app-tree-subdivision>
                      }
                      @if (isTrilha(item)) {
                        <app-tree-trail [trail]="item" [last]="last" [first]="first"></app-tree-trail>
                      }
                    </div>
                  }
                </div>
              </div>
            } @else {
              <div class="flex h-[75vh] w-full items-center justify-center bg-gray-50">
                <div class="flex flex-col items-center">
                  <svg-icon src="assets/icons/icon-arrow-enter.svg"></svg-icon><br />
                  @if (!form.value.id) {
                    <p class="pb-2 text-center text-lg text-[#808080]">
                      {{ 'trilhas.estudio.curso.gerenciar' | translate }}<br />
                      {{ 'trilhas.estudio.curso.dados-gerais-curso' | translate }}
                    </p>
                  } @else if (form?.value?.id) {
                    <div class="flex gap-5">
                      <button
                        (click)="openSidenav()"
                        app-button
                        type="button"
                        class="flex gap-2 bg-theme-500 px-4 py-2 uppercase text-theme-contrast"
                      >
                        <svg-icon class="h-4 w-4" src="assets/icons/icon-more.svg"></svg-icon>
                        {{ 'trilhas.estudio.curso.subdivisao' | translate }}
                      </button>
                      <button
                        app-button
                        type="button"
                        (click)="onAddTrail()"
                        class="flex gap-2 bg-theme-500 px-4 py-2 uppercase text-theme-contrast"
                      >
                        <svg-icon class="h-4 w-4" src="assets/icons/icon-more.svg"></svg-icon>
                        {{ 'trilhas.estudio.curso.trilha' | translate }}
                      </button>
                    </div>
                  }
                </div>
              </div>
            }
          } @else {
            <div class="flex flex-col gap-5 py-5 pl-10 pr-10">
              @for (entitiy of [1, 2, 3]; track entitiy) {
                <app-card
                  class="h-[70px] border-theme-500 bg-base-glacier-50 pr-3 [box-shadow:0px_2px_4px_0px_rgba(0,0,0,0.15)]"
                >
                  <div app-card-content class="px-3! py-2! text-start">
                    <app-skeleton class="block h-[58px]! w-full"></app-skeleton>
                  </div>
                </app-card>
              }
            </div>
          }
          @if (!!form.value.id && opened$ | async) {
            <div class="h-auto bg-gray-50">
              <ng-template app-sidenav-end [opened]="true" [mode]="1">
                <div class="p-6!">
                  <div class="flex items-baseline gap-2 pb-2">
                    @if (!formSubdivision.value.id) {
                      <p class="text-xl font-bold">
                        {{ 'trilhas.estudio.curso.nova' | translate }}
                      </p>
                    } @else {
                      <p class="text-xl font-bold">{{ 'trilhas.estudio.curso.editar' | translate }}</p>
                    }
                    <p class="text-xl font-medium">{{ 'trilhas.estudio.curso.subdivisao' | translate }}</p>
                  </div>
                  <hr app-divider />
                  <div class="w-full pt-4">
                    <app-form-field>
                      <label class="text-[14px]!" app-label>{{ 'trilhas.estudio.curso.nome' | translate }}</label>
                      <input
                        app-input
                        (change)="onChangeCharacterSubdivision()"
                        maxlength="70"
                        minlength="3"
                        [formControl]="formSubdivision.controls.nome"
                        [placeholder]="'trilhas.estudio.placeholder-nome-subdivisao' | translate"
                      />
                    </app-form-field>
                    <div class="flex items-center gap-2">
                      <app-switch [formControl]="formSubdivision.controls.fixar"></app-switch>
                      <label class="px-2 pb-0! text-[14px]!" app-label>{{
                        'trilhas.estudio.curso.fixar' | translate
                      }}</label>
                      <svg-icon src="assets/icons/icon-interrogation.svg"></svg-icon>
                    </div>
                    <div class="flex flex-col items-start gap-2 self-stretch pt-2">
                      <p class="text-[14px]!" translate>trilhas.estudio.curso.imagem</p>
                      <app-upload-file
                        class="w-full"
                        [config]="config"
                        [image]="subthumbnailLink"
                        [invalid]="formSubdivision.controls.thumbnail.invalid && submittedSubdivision$ | async"
                        (statusChange)="onUploadThumbnailSubdivision($event)"
                        (processing)="disableSendUploadThumbnailSubdivision($event)"
                        (queueComplete)="enableSendOnUploadThumbnailSubdivision($event)"
                      ></app-upload-file>
                    </div>
                    <div class="flex justify-between gap-5 pt-4">
                      <button
                        (click)="closeSidenav()"
                        app-outline-button
                        type="button"
                        class="h-10! w-48! border-base-status-danger text-base-status-danger hover:[&:not([disabled])]:bg-base-status-danger hover:[&:not([disabled])]:text-theme-contrast"
                      >
                        <svg-icon src="assets/icons/icon-more.svg"></svg-icon>
                        {{ 'trilhas.estudio.curso.cancel' | translate }}
                      </button>
                      @if (!formSubdivision.value.id) {
                        <button
                          (click)="onSubmitSubdivision()"
                          [disabled]="subThumbInvalid$ | async"
                          app-outline-button
                          type="button"
                          class="group w-48 border-theme-500 text-theme-500 hover:[&:not([disabled])]:bg-theme-500 hover:[&:not([disabled])]:text-theme-contrast"
                        >
                          @if (subThumbInvalid$ | async) {
                            <app-skeleton
                              class="flex h-5 w-5"
                              baseStyle="bg-theme-500"
                              [showLabel]="false"
                            ></app-skeleton>
                          } @else {
                            <svg-icon
                              class="mr-2 flex w-5 text-theme-500 group-hover:text-theme-contrast"
                              src="assets/icons/icon-plus.svg"
                            ></svg-icon>
                          }
                          {{ 'trilhas.estudio.curso.add' | translate }}
                        </button>
                      } @else {
                        <button
                          (click)="onSubmitSubdivision()"
                          [disabled]="subThumbInvalid$ | async"
                          app-outline-button
                          type="button"
                          class="w-48 border-theme-500 text-theme-500 hover:[&:not([disabled])]:bg-theme-500 hover:[&:not([disabled])]:text-theme-contrast"
                        >
                          {{ 'trilhas.estudio.curso.salvar' | translate }}
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          }
        </div>
      } @else {
        <div class="flex h-[75vh] w-full items-center justify-center bg-gray-50">
          <div class="flex flex-col items-center">
            <svg-icon src="assets/icons/icon-arrow-enter.svg"></svg-icon><br />
            @if (!form.value.id) {
              <p class="pb-2 text-center text-lg text-[#808080]">
                {{ 'trilhas.estudio.curso.gerenciar' | translate }}<br />
                {{ 'trilhas.estudio.curso.dados-gerais-curso' | translate }}
              </p>
            } @else if (form?.value?.id) {
              <div class="flex gap-5">
                <button
                  (click)="openSidenav()"
                  app-button
                  type="button"
                  class="flex gap-2 bg-theme-500 px-4 py-2 uppercase text-theme-contrast"
                >
                  <svg-icon class="h-4 w-4" src="assets/icons/icon-more.svg"></svg-icon>
                  {{ 'trilhas.estudio.curso.subdivisao' | translate }}
                </button>
                <button
                  app-button
                  type="button"
                  (click)="onAddTrail()"
                  class="flex gap-2 bg-theme-500 px-4 py-2 uppercase text-theme-contrast"
                >
                  <svg-icon class="h-4 w-4" src="assets/icons/icon-more.svg"></svg-icon>
                  {{ 'trilhas.estudio.curso.trilha' | translate }}
                </button>
              </div>
            }
          </div>
        </div>
      }
    </ng-template>
  </app-sidenav-group>
</div>
<ng-template #modalCertificadoPreview let-modal>
  <app-card class="h-full overflow-y-auto">
    <div app-card-header>
      <h1 class="text-lg">
        {{ form.value.sugestao_certificado.titulo }}
      </h1>
    </div>
    <hr app-divider class="my-5" />
    <div class="h-full overflow-y-auto" app-card-content>
      <app-preview-certificado [data]="onData()"></app-preview-certificado>
    </div>
    <hr app-divider class="my-5" />
    <div app-card-footer class="flex gap-1">
      <button (click)="onClose()" app-button class="bg-red-500 text-theme-contrast">
        {{ 'geral.fechar' | translate }}
      </button>
    </div>
  </app-card>
</ng-template>
